import { assetUrl } from '../http/build-url';
import { asNumber, asString, asStringArray } from '../http/normalise';
import { ApiEventDocument } from './document.dto';
import {
  DocumentSource,
  DocumentVisibility,
  EventDocument,
} from './document.model';

function asSource(value: unknown): DocumentSource {
  return value === 'external-link' ? 'external-link' : 'upload';
}

function asVisibility(value: unknown): DocumentVisibility {
  return value === 'registrants-only' ? 'registrants-only' : 'public';
}

export function mapEventDocument(
  dto: ApiEventDocument,
  storageBase: string
): EventDocument {
  const source = asSource(dto.source);
  const rawUrl = asString(dto.url) ?? '';

  return {
    id: asString(dto.id) ?? '',
    eventId: asString(dto.eventId) ?? '',
    title: asString(dto.title) ?? '',
    description: asString(dto.description),
    source,
    url:
      source === 'external-link' ? rawUrl : assetUrl(storageBase, rawUrl) ?? '',
    assetPath: source === 'upload' && rawUrl !== '' ? rawUrl : null,
    categoryIds: asStringArray(dto.categoryIds),
    sessionId: asString(dto.sessionId),
    speakerId: asString(dto.speakerId),
    visibility: asVisibility(dto.visibility),
    downloadCount: asNumber(dto.downloadCount) ?? 0,
    sizeBytes: asNumber(dto.sizeBytes),
    updatedAt: asString(dto.updatedAt) ?? '',
  };
}
